export default function (object, callable) {
    return Object.keys( object ).reduce( ( result, key ) => {
        result[ key ] = callable( object [ key ] );
        return result;
    }, {});
}